import { useEffect, useState } from 'react';
import { SDKLibrary } from '../types/sdk';

const params = new URLSearchParams(window.location.search);
const useStagedLoader = params.get('useStagedLoader');
const libraryURL = useStagedLoader 
  ? 'https://aurora-sdk.s3.amazonaws.com/client-sdk-loader.next-staging.js'
  : 'https://aurora-sdk.s3.amazonaws.com/client-sdk-loader.next.js';

/**
 * Asynchronously import the SDK library
 */
export function useSDKLibrary() {
    const [library, setSDKLibrary] = useState<SDKLibrary | null>(null);
    if (useStagedLoader) {
      console.warn('Using staged loader: ', libraryURL);
    }
    useEffect(() => {
      import(/* webpackIgnore: true */ libraryURL)
        .then((result) => setSDKLibrary(result));
    }, [])
    
    return { library };
  }